import { SuperHeroProps } from "@bluebottlecoffee/design-system/components";
import {
  Hero as HeroSchema,
  HeroResponsive as HeroResponsiveSchema,
} from "../sanity-schema";
import { toHeroProps } from "./hero";
import { AriaTranslations } from "../sanity/shared";

export function selectHeroes(
  hero: HeroSchema | HeroResponsiveSchema,
  heroResponsive: (HeroSchema | HeroResponsiveSchema)[],
): (HeroSchema | HeroResponsiveSchema)[] {
  return heroResponsive?.length > 0 ? heroResponsive : [hero];
}

export function toSuperHeroProps(
  data: (HeroSchema | HeroResponsiveSchema)[],
  aria: AriaTranslations,
  region: string,
  lang: string,
): SuperHeroProps {
  return {
    ...(aria?.previousImage &&
      aria?.nextImage && {
        ariaCopy: {
          previousImage: aria.previousImage,
          nextImage: aria.nextImage,
        },
      }),
    heroes: data.map((h) => toHeroProps(h, region, lang)),
  };
}

export function toNarrowSuperHeroProps(
  data: (HeroSchema | HeroResponsiveSchema)[],
  aria: AriaTranslations,
  region: string,
  lang: string,
): {
  superHeroProps: SuperHeroProps;
  heading: string | undefined;
  description: string | undefined;
} {
  const { ariaCopy, heroes } = toSuperHeroProps(data, aria, region, lang);
  return {
    superHeroProps: {
      ariaCopy,
      heroes: heroes.map((h) => ({
        ...h,
        heading: undefined,
        description: undefined,
      })),
    },
    heading: heroes[0]?.heading,
    description: heroes[0]?.description,
  };
}
